var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 3,
    viewBox: "0 0 16 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.03159C15.9993 1.58387 15.551 2.031 14.9987 2.03028L9 2.02242L8 2.02242L7 2L7 2.01979L0.99869 2.01193C0.446405 2.0112 -0.000722953 1.5629 9.09499e-07 1.01062C0.000724772 0.458333 0.449026 0.0112059 1.00131 0.0119298L7 0.0197926C7 0.000110859 8 -3.49691e-07 8 -3.49691e-07C8 -3.49691e-07 9 -3.1343e-07 9 0.0198747L9 0.0224139L15.0013 0.03028C15.5536 0.0310039 16.0007 0.479305 16 1.03159Z",
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/MinusIcon.4ac0e8ecc27faaf19b8b34437b8600f7.svg";
export { ForwardRef as ReactComponent };